module.exports = __webpack_public_path__ + "media/grend_frauen.d7e21a2e.mp4";